import { render, staticRenderFns } from "./endorseTimeHintDialog.vue?vue&type=template&id=351ae577&scoped=true&"
import script from "./endorseTimeHintDialog.vue?vue&type=script&lang=js&"
export * from "./endorseTimeHintDialog.vue?vue&type=script&lang=js&"
import style0 from "./endorseTimeHintDialog.vue?vue&type=style&index=0&id=351ae577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ae577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351ae577')) {
      api.createRecord('351ae577', component.options)
    } else {
      api.reload('351ae577', component.options)
    }
    module.hot.accept("./endorseTimeHintDialog.vue?vue&type=template&id=351ae577&scoped=true&", function () {
      api.rerender('351ae577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/endorseTimeHintDialog.vue"
export default component.exports